import { createAnalyticsService } from "@ecommerce/http-services";
import { AnalyticsConfig, AnalyticsInitOptions } from "./analytics.types";
import {
  AnalyticsConfigTypeEnum,
  MIXPANEL_PROJECT_ID,
  PIXEL_PROJECT_ID,
} from "./types";
import { initMixpanel } from "./providers/mixpanel";
import { initMetaPixel } from "./providers/metaPixel";

export function searchConfig(
  tipoAnalytics: AnalyticsConfigTypeEnum,
  nombreCampoAnalyticsConfig: string,
  configs: AnalyticsConfig[]
): string | undefined {
  return configs
    .filter(
      (c) =>
        c.codAnalyticsConfigTipo === tipoAnalytics &&
        c.nombreCampoConfig === nombreCampoAnalyticsConfig
    )
    .map((c) => c.valorCampoConfig)
    .find(Boolean);
}

/**
 * Inicializa analytics cargando la configuración desde el backend
 */
export async function initAnalyticsFromApi(httpClient: any): Promise<void> {
  try {
    const analyticsService = createAnalyticsService(httpClient);
    const config = await analyticsService.getConfiguration<AnalyticsConfig>();

    const mixPanelProjectId = searchConfig(
      AnalyticsConfigTypeEnum.Mixpanel,
      MIXPANEL_PROJECT_ID,
      config
    );
    const metaPixelId = searchConfig(
      AnalyticsConfigTypeEnum.MetaPixel,
      PIXEL_PROJECT_ID,
      config
    );

    if (mixPanelProjectId) initMixpanel(mixPanelProjectId);
    if (metaPixelId) initMetaPixel(metaPixelId);
  } catch (err) {
    console.error("Error al intentar iniciar analytics:", err);
  }
}

/**
 * Inicializa analytics con opciones provistas directamente
 */
export function initAnalytics(options: AnalyticsInitOptions): void {
  if (options.mixpanelProjectId) {
    initMixpanel(options.mixpanelProjectId);
  }
  if (options.metaPixelId) {
    initMetaPixel(options.metaPixelId);
  }
  // Aquí se pueden agregar más providers en el futuro
}

